var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "side-page",
        class: { active: _vm.isActive },
        attrs: { id: "side-page" }
      },
      [
        _c(
          "div",
          { attrs: { id: "side-page-wrapper" } },
          [
            _c("div", { attrs: { id: "side-page-controls-container" } }, [
              _c(
                "div",
                {
                  staticClass: "side-page-controls",
                  attrs: { id: "side-page-controls" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "side-page-close-btn",
                      staticStyle: {
                        position: "relative",
                        width: "20px",
                        height: "20px"
                      },
                      on: {
                        click: function($event) {
                          return _vm.skrytSidePage()
                        }
                      }
                    },
                    [
                      _c("span", {
                        staticClass: "ox-toggler__bar",
                        staticStyle: {
                          position: "absolute",
                          transform: "rotate(-45deg)",
                          top: "50%",
                          left: "0"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "ox-toggler__bar",
                        staticStyle: {
                          position: "absolute",
                          transform: "rotate(45deg)",
                          top: "50%",
                          left: "0"
                        }
                      })
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _vm._t("default")
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }